import { useState } from 'react'

// local
// import { IFilteredGymSalonList } from 'types/GymType'

export default function useGymSalonReservationModal<T>() {
  const [selectedSalon, setSelectedSalon] = useState<T | undefined>()
  const [modal, setModal] = useState(false)
  const [notification, setNotification] = useState(false)

  const closeModal = () => setModal(false)
  const openModal = (salon?: T) => {
    setModal(true)
    if (salon) setSelectedSalon(salon)
  }

  return {
    selectedSalon,
    setSelectedSalon,
    modal,
    openModal,
    closeModal,
    notification,
    setNotification,
  }
}
